import { createTransform } from "redux-persist";
import { initialLoadingState } from "../reducers/loadingStateReducer";

const resetLoadingStateTransform = createTransform(
  (inboundState) => inboundState,
  () => ({ ...initialLoadingState }),

  { whitelist: ["loadingStateReducer"] }
);

export default resetLoadingStateTransform;
